'use strict';
var url = require('url');
var prependHttp = require('prepend-http');

module.exports = function (x) {
	var withProtocol = prependHttp(x);
	var parsed = url.parse(withProtocol);

	if (withProtocol !== x) {
		parsed.protocol = null;
	}

	return parsed;
};



//////////////////
// WEBPACK FOOTER
// ./~/url-parse-lax/index.js
// module id = 991
// module chunks = 0 1 2 3